import { getTenantMembershipForUser } from './tenantContextLoaders';
import { tryGetTenantMembershipFromJwt } from './tenantMembershipFromJwt';

/**
 * Option β: prefer JWT tenant claims when valid; optional DB-only path after deactivation RPC.
 */
export async function resolveTenantMembershipForUser(user, { forceTenantMembershipFetch = false } = {}) {
  if (!forceTenantMembershipFetch) {
    const fromJwt = tryGetTenantMembershipFromJwt(user);
    if (fromJwt) return fromJwt;
  }
  return getTenantMembershipForUser(user.id);
}
